import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Variables } from '../../../Variations/Variations';

const LinkedProducts = (props) => {
  const [products, setProducts] = useState([]);

  // Fetch assigned selections
  const fetchAssignedUpSells = async () => {
    const res = await fetch(
      `${Variables.API_URL}AssignUpSellsToProduct/GetAssignedUpSells/${props.ProductID}`
    );
    if (res.ok) props.setSelectedUpSells(await res.json());
  };

  const fetchAssignedCrossSells = async () => {
    const res = await fetch(
      `${Variables.API_URL}AssignCrossToProduct/GetAssignedCross/${props.ProductID}`
    );
    if (res.ok) props.setSelectedCrossSells(await res.json());
  };

  // Fetch all available products
  const fetchProducts = async () => {
    const res = await fetch(
      `${Variables.API_URL}Products/GetProductsForAssigningUpAndCross`
    );
    if (res.ok) setProducts(await res.json());
  };

  // Load on mount or when ProductID changes
  useEffect(() => {
    fetchAssignedUpSells();
    fetchAssignedCrossSells();
    fetchProducts();
  }, [props.ProductID]);

  // Prepare react-select options & values
  const options = products.map(p => ({ value: p.ProductId, label: p.ProductName }));
  const selectedUpOptions = (props.selectedUpSells || []).map(p => ({ value: p.ProductId, label: p.ProductName }));
  const selectedCrossOptions = (props.selectedCrossSells || []).map(p => ({ value: p.ProductId, label: p.ProductName }));

  return (
    <>
      <div className="row">
        <div className="col-lg-3"><label>Upsells</label></div>
        <div className="col-lg-6">
          <Select
            isMulti
            options={options}
            value={selectedUpOptions}
            placeholder="Select upsells…"
            onChange={opts =>
              props.setSelectedUpSells(
                (opts || []).map(o => ({ ProductId: o.value, ProductName: o.label }))
              )
            }
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-lg-3"><label>Cross-sells</label></div>
        <div className="col-lg-6">
          <Select
            isMulti
            options={options}
            value={selectedCrossOptions}
            placeholder="Select cross-sells…"
            onChange={opts =>
              props.setSelectedCrossSells(
                (opts || []).map(o => ({ ProductId: o.value, ProductName: o.label }))
              )
            }
          />
        </div>
      </div>
    </>
  );
};

export default LinkedProducts;
